/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

const buildParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(
      ([key, value]) => value !== undefined && (value !== '' || key === 'q')
    )
  ).toString();

class CompaniesAPI extends CacheEnabledApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'company';
  }

  // Vuex cache client: get(false, { per_page: 5000 })
  // Pinia / upstream CRM: get({ page, sort, ... })
  get(cacheOrParams = false, params = {}) {
    if (typeof cacheOrParams === 'boolean' || cacheOrParams == null) {
      return super.get(cacheOrParams ?? false, params);
    }

    if (typeof cacheOrParams === 'object' && !Array.isArray(cacheOrParams)) {
      const { page = 1, sort = 'name', ...rest } = cacheOrParams;
      return axios.get(this.url, {
        params: { page, sort, ...rest },
      });
    }

    return super.get(false, params);
  }

  search(query = '', page = 1, sort = 'name') {
    const requestURL = `${this.url}/search?${buildParams({ q: query, page, sort })}`;
    return axios.get(requestURL);
  }

  listContacts(id, page = 1) {
    return axios.get(`${this.url}/${id}/contacts?${buildParams({ page })}`);
  }

  listNotes(id) {
    return axios.get(`${this.url}/${id}/notes`);
  }

  listConversations(id) {
    return axios.get(`${this.url}/${id}/conversations`);
  }

  searchContacts(id, query = '', page = 1) {
    const requestURL = `${this.url}/${id}/contacts/search?${buildParams({ q: query, page })}`;
    return axios.get(requestURL);
  }

  createContact(id, payload) {
    return axios.post(`${this.url}/${id}/contacts`, payload);
  }

  removeContact(id, contactId) {
    return axios.delete(`${this.url}/${id}/contacts/${contactId}`);
  }

  destroyCustomAttributes(id, customAttributes) {
    return axios.post(`${this.url}/${id}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAvatar(id) {
    return axios.delete(`${this.url}/${id}/avatar`);
  }
}

export default new CompaniesAPI();
